import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import { Box, Container, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import React from "react";

const CopyRight = ({ bgcolor }) => {
  const TikTokIcon = ({ color = "#000000" }) => {
    return (
      <svg
        fill={bgcolor ? color : "#161c2d"}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
        width="1.5rem"
        height="1.5rem"
      >
        <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z" />
      </svg>
    );
  };

  const socialIcons = [
    {
      icon: <XIcon />,
      name: "twitter",
      link: "https://x.com/eaziday_",
    },
    {
      icon: <FacebookOutlinedIcon />,
      name: "facebook",
      link: "https://www.facebook.com/share/18tJqLAuMz/?mibextid=wwXIfr",
    },
    {
      icon: <InstagramIcon />,
      name: "instagram",
      link: "https://www.instagram.com/eaziday_?igsh=OGJnaWp0djc2cTFo",
    },
    {
      icon: <LinkedInIcon />,
      name: "linkdin",
      link: "https://www.linkedin.com/company/eazi-day/",
    },
    {
      icon: <TikTokIcon color="white" />,
      name: "tiktok",
      link: "https://www.tiktok.com/@eazi.day?lang=en",
    },
  ];

  const renderSocialIcons = () => {
    return (
      <Stack direction={"row"} alignItems={"center"} gap={1.5}>
        {socialIcons?.map((val, ind) => {
          return (
            <Box
              key={ind}
              component={"a"}
              href={val.link}
              target="_blank"
              sx={{
                "& .MuiSvgIcon-root ": {
                  color: bgcolor ? "text.white" : "text.raisinBlack",
                  "&:hover": {
                    color: "text.orangeRed",
                  },
                },
              }}
            >
              {val.icon}
            </Box>
          );
        })}
      </Stack>
    );
  };
  return (
    <Container
      sx={{ py: 3, px: { xs: 1.5, sm: 0 }, maxWidth: "1100px !important" }}
    >
      <Stack
        direction={{ sm: "row" }}
        alignItems={"center"}
        justifyContent={"space-between"}
        gap={1}
      >
        <Typography
          variant="body1"
          fontWeight={400}
          color={bgcolor ? "text.white" : "text.raisinBlack"}
        >
          {t("footerCopyright", {
            currentYear: new Date().getFullYear(),
          })}
        </Typography>
        <Stack
          direction={{ sm: "row" }}
          gap={{ xs: 1, sm: 3 }}
          alignItems={"center"}
        >
          {renderSocialIcons()}
        </Stack>
      </Stack>
    </Container>
  );
};

export default CopyRight;
